import { Injectable, } from "@angular/core";
import {
    HttpClient,
  } from '@angular/common/http'

import { AuthConfig, JwksValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: environment.VIPPS_OAUTH_ISSUER,

  // URL of the SPA to redirect the user to after login
  redirectUri: environment.VIPPS_REDIRECT_URL,

  // The SPA's id. The SPA is registerd with this id at the auth-server
  // clientId: 'server.code',
  clientId: environment.VIPPS_CLIENT_ID,
  requireHttps: false,
  strictDiscoveryDocumentValidation: false,
  skipIssuerCheck: true,

  // Just needed if your auth server demands a secret. In general, this
  // is a sign that the auth server is not configured with SPAs in mind
  // and it might not enforce further best practices vital for security
  // such applications.
  // dummyClientSecret: 'secret',

  responseType: 'code',

  // set the scope for the permissions the client should request
  // The first four are defined by OIDC.
  // Important: Request offline_access to get a refresh token
  // The api scope is a usecase specific one
  scope: `${environment.VIPPS_SCOPES}`,
  tokenEndpoint: `${environment.API_URL}/vipps/token`,

  showDebugInformation: true,
  sessionChecksEnabled: true,
  clearHashAfterLogin: false,
  
};

@Injectable({
    providedIn: 'root'
})
export class VippsService{
    oauth: any

    constructor(
        private http: HttpClient,
        private oauthService: OAuthService,
        private router: Router,
    ){
        this.oauthService.initCodeFlow()
        this.oauthService.configure(authConfig);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    }

    getUserInfo(): Promise<any>{
        return this.oauthService.tryLoginCodeFlow().then(()=>{
            return this.http.get(`${environment.API_URL}/vipps/vipps-userinfo-api/userinfo`, {headers: {
                Authorization: `Bearer ${this.oauthService.getAccessToken()}`
            }}).toPromise()
        })
    } 

    async logout(){
        try {
            await this.oauthService.revokeTokenAndLogout().finally(()=>{
                this.oauthService.logOut()
                window.location.replace('/')
            })
        } catch (error) {
            this.oauthService.logOut()
            window.location.replace('/')
        }

        this.oauthService.logOut()
        window.location.replace('/')
    }

    authorize(){
        this.oauthService.loadDiscoveryDocument().then(doc => {
            this.oauthService.tryLogin()
                .catch(err => {
                    console.error(err);
                })
                .then(() => {
                    if(!this.oauthService.hasValidAccessToken()) {
                        this.oauthService.initCodeFlow()
                    }
                });
          });
        }
}